import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Regular from "./Assistant-Regular.woff2";

export const AssistantFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: Regular,
    descriptors: {
      weight: "400",
      style: "normal",
    },
  },
];
